import React, { Component } from 'react';
import Path from '../routes/routes-path';
import ReactTooltip from 'react-tooltip';
import './class.scss';
import SetupClass from './add-new-class/add-new-class'
import SetupSection from './setup-section/setup-section'
import { ImageConstants, AccessRights } from '../../constants/constants';
import { getImageSource } from '../../utility/image-source';
import StudentList from './student-list/student-list'
import SchoolApi from '../../apis/school'
import AddStudentComponent from './add-student/add-student';
import CWConfirm from '../common/cw-confirmation-modal/cw-confirmation-modal'
import SessionCache from '../routes/session-cache';
import { Modal, ModalBody } from "reactstrap";
import DeleteSection from './delete-section/delete-section'
import PillButtonSelect from '../common/pill-button-select/pill-button-select';
import AddTeacher from './add-teacher/add-teacher'
import ToasterComponent from '../common/cw-toaster-component/cw-toaster-component';
import Services from '../../../service/service';

class Classes extends Component {
    state = {
        selectedTabValue: '',
        showSetupClass: false,
        tabs: [],
        boards: [],
        sections: [],
        showStudentList: false
    }
    classes = []
    accessRights = SessionCache.getAllowedModule()

    showStudentList = (item) => {



        this.setState({ showStudentList: true, selectedSection: item })
    }


    componentDidMount() {
        this.getClasses()
    }

    getClasses(payload = {}) {
        SchoolApi.getClassAndBoard(payload)
            .then(school => {
                let classes = [], boards = [];
                this.classes = []
                for (let i = 0; i < school.classes.length; i++) {

                    classes.push({
                        title: school.classes[i].name,
                        value: school.classes[i].name,
                    })
                    this.classes.push(school.classes[i].name)

                }

                for (let i = 0; i < school.boards.length; i++) {
                    boards.push({
                        title: school.boards[i].name,
                        value: school.boards[i].name,
                    })
                }

                let selectedBoard = boards[0].value

                this.getSections({ class: school.classes[0].name, board: selectedBoard })
                this.setState({ tabs: classes, selectedTabValue: school.classes[0].name, boards, selectedBoard })
            }).catch(err => {
            })
    }

    getSections(payload = {}, deleted) {

        console.log(deleted)

        if (!payload.class) payload.class = this.state.selectedTabValue
        if (!payload.board) payload.board = this.state.selectedBoard

        SchoolApi.getSections(payload)
            .then(response => {
                console.log(response)
                let user = SessionCache.getUser()

                let value = user.schoolInfo.totalSections

                if (!value && response.response.length) {
                    user.schoolInfo.totalSections = response.response.length
                }

                if (deleted) {
                    user.schoolInfo.totalSections -= 1
                }


                SessionCache.setUser(user)
                let sideMenuService = Services.getSideMenu()
                if (sideMenuService) sideMenuService.refreshSideMenu()

                this.setState({ sections: response.response, unAssignedUsers: response.unAssignedUsers })
            }).catch(err => {
            })
    }

    showSetupClass = () => {
        this.setState({ showSetupClass: true })
    }

    showSetupSection = (value) => {
        this.setState({ showSetupSection: true, hideSectionName: value })
    }

    hideSetupClass = (reFetch) => {
        if (reFetch) {
            if (reFetch === true) this.showToaster('info', 'Section added or updated successfully')
            // if(response.response !== 0) {
            // function refreshPage() {
            // setTimeout(()=>{
            // window.location.reload(false);
            // }, 500);
            console.log('page to reload')
            // }  
            // }
            this.getSections()

            let user = SessionCache.getUser()
            let value = user.schoolInfo.totalSections
            if (value) {
                let sideMenuService = Services.getSideMenu()
                if (sideMenuService) sideMenuService.refreshSideMenu()
            }

        }
        this.setState({ showSetupClass: false, showSetupSection: false })
    }

    onClickTab = (value) => {
        this.setState({ selectedTabValue: value }, () => {
            this.getSections()
        })
    }

    onClickAddStudent(item, index) {
        this.setState({ openAddStudent: true, selectedClass: item, addStudentIndex: index })
    }

    onClickAddTeacher(item, index) {
        this.setState({ openAddTeacher: true, selectedClass: item, addTeacherIndex: index })
    }

    closeAddStudentModal = () => {
        this.setState({ openAddStudent: false, })
    }

    closeAddTeacherModal = () => {
        this.setState({ openAddTeacher: false })
    }

    onTeacherAdded = () => {
        this.getSections()
        this.closeAddTeacherModal()
    }

    onSaveStudent = () => {
        let sections = this.state.sections
        if (!sections[this.state.addStudentIndex].numberOfStudents) sections[this.state.addStudentIndex].numberOfStudents = 1
        else sections[this.state.addStudentIndex].numberOfStudents += 1
        this.setState({ sections, openAddStudent: false, })
    }

    showConfirmModal = (item) => {

        if (!item.numberOfStudents) {
            let deleteMessage = `Are you sure want to delete the section ${item.section}`
            this.setState({ deleteItem: item, showConfirmModal: true, deleteMessage })
        } else {
            this.setState({ deleteItem: item, showDeleteModal: true })
        }
    }


    hideConfirmModal = () => {
        this.setState({ showConfirmModal: false, showDeleteModal: false, showAddTeacher: false })
    }

    removeSection = () => {
        let payload = { _id: this.state.deleteItem._id }
        SchoolApi.deleteSchoolSection(payload)
            .then(response => {
                this.getSections({}, true)
                this.hideConfirmModal()
            }).catch(err => {
                console.log(err)
            })
    }

    onDeleteSuccess = () => {
        this.getSections()
        this.hideConfirmModal()
    }

    handleback = (reFetch) => {
        // if (reFetch) {
        this.getSections()
        // }
        this.setState({ showStudentList: false })
    }

    onSelectPillButton = (value, key) => {
        this.setState({ [key]: value }, () => {
            this.getSections()
        })
    }

    getTeacherName(teachers) {

        let name = teachers.map(item => item.firstName)
        let len = name.length
        if (name.length > 2) {
            name.length = 2
            name = name.join(", ")
            return `${name} +${len - 2}`
        }
        return name.join(", ")
    }

    onCLickAssign = () => {
        let url = `${Path.STUDENTS}?b=${this.state.selectedBoard}&c=${this.state.selectedTabValue}&unassign=true`
        this.props.history.push(url)
    }

    renderSectionsList = () => {

        return (
            <div className="">
                <div className="row">
                    <div className="col text-right">
                        {this.state.sections[0]?.section == "No Sections" ?
                            <div>
                                {
                                    this.accessRights[AccessRights.SETUP_SECTION] ? <div className="d-inline-block blue-button mt-4" onClick={() => this.showSetupSection(false)}>Add Sections</div> : ""
                                }
                            </div>
                            :
                            <div>
                                {this.state.unAssignedUsers ?
                                    <div className="d-inline-block  mx-2">
                                        <span className=" blue-button mt-4" onClick={this.onCLickAssign}>Assign Section to Students </span>
                                        <div className="ml-5 pt-2 un-assigned-text"> {this.state.unAssignedUsers || 0} students from {this.state.selectedTabValue} have no section assigned</div>
                                    </div> : ""}
                                {
                                    this.accessRights[AccessRights.SETUP_SECTION] ? <div className="d-inline-block blue-button mt-4" onClick={() => this.showSetupSection(false)}>Add Sections</div> : ""
                                }
                            </div>
                        }


                    </div>
                </div>
                <div id="table-scoll" className="table-responsive mt-3">
                    <table className="table cw-table">
                        <thead>
                            <tr>
                                <th className='th-left-radius'>Section</th>
                                <th>Maths Teacher</th>
                                <th>Students</th>
                                <th className='th-right-radius'>
                                    {
                                        this.accessRights[AccessRights.EDIT_CLASS] || this.accessRights[AccessRights.DELETE_CLASS] ? "Details" : ""

                                    }
                                </th>
                            </tr>
                        </thead>
                        <tbody className="bg-white">
                            {
                                this.state.sections && this.state.sections.length ? this.state.sections.map((item, index) => (
                                    <tr className="mt-4" onMouseEnter={ReactTooltip.rebuild}>
                                        <td>{item?.section == 'No Sections' ?

                                            <span >
                                                <span className="no-section">No Sections</span> <img className="add-icon cursor-pointer" src={getImageSource(ImageConstants.ADD)} onClick={() => this.showSetupSection(false)} data-tip={"Add Sections"} />
                                            </span>

                                            : <span>{item.section}</span>}</td>
                                        <td>
                                            {
                                                item.teacher?.length ?
                                                    <span> <span className="pr-2">{this.getTeacherName(item.teacher)}</span> <img className="add-icon cursor-pointer" src={getImageSource(ImageConstants.ADD)} onClick={() => this.onClickAddTeacher(item, index)} data-tip={"Add Teachers"} /> </span>
                                                    :
                                                    <div>
                                                        <div className="red-dot d-inline-block"> &nbsp; </div>
                                                        <div className='cw-button-primary-rounded cw-btn-sm' onClick={() => this.onClickAddTeacher(item, index)} data-tip={"Add Teachers"}>
                                                            Add Teacher
                                                        </div>
                                                    </div>
                                            }

                                        </td>
                                        <td>
                                            {
                                                this.state.sections[0]?.section == "No Sections" ?
                                                    <span><span className="pr-2">{this.state.unAssignedUsers || 0}</span> <img className="add-icon" src={getImageSource(ImageConstants.ADD)} onClick={() => this.props.history.push({ pathname: '/school/students', state: { sectionDetail: item } })} /> </span>
                                                    : <div>
                                                        {
                                                            // <a >
                                                            //     View Engagement
                                                            // </a>
                                                            item.numberOfStudents ?
                                                                <span >
                                                                    <span className="pr-2">{item.numberOfStudents || 0}</span>
                                                                    <img className="add-icon cursor-pointer" src={getImageSource(ImageConstants.ADD)}
                                                                        data-tip={"Add Students"}
                                                                        onClick={() => this.props.history.push({ pathname: '/school/students', state: { sectionDetail: item } })} />
                                                                </span>
                                                                :
                                                                <div>
                                                                    <div className="red-dot d-inline-block"> &nbsp; </div>
                                                                    <div className='cw-button-primary-rounded cw-btn-sm' onClick={() => this.props.history.push({ pathname: '/school/students', state: { sectionDetail: item } })} data-tip={"Add Students"}>
                                                                        Add Student
                                                                    </div>
                                                                </div>
                                                        }
                                                    </div>

                                            }
                                        </td>
                                        <td className="">
                                            {
                                                this.accessRights[AccessRights.EDIT_CLASS] ?
                                                    <span className="p-2">
                                                        <img className="vector-icon pt-2 cursor-pointer" src={getImageSource(ImageConstants.EDIT)} onClick={() => this.showStudentList(item)} />
                                                    </span> : ""
                                            }
                                            {
                                                this.accessRights[AccessRights.DELETE_SECTION] ?
                                                    <span className="p-2" onClick={() => { this.showConfirmModal(item) }}>
                                                        <img className="vector-icon pt-2 cursor-pointer" src={getImageSource(ImageConstants.DELETE_RED)} />
                                                    </span> : ""
                                            }
                                        </td>
                                    </tr>
                                ))
                                    : <tr className="bg-white pt-4"><td colSpan="11" align='center'>No Records found</td></tr>
                            }
                        </tbody>
                    </table>
                </div >
            </div>
        )
    }

    showToaster(type, message) {
        this.setState(
            {
                showToaster: true,
                toasterMessage: message,
                toasterType: type
            },
            () => {
                setTimeout(() => {
                    this.hideToaster()
                }, 3000)
            }
        )
    }

    hideToaster() {
        this.setState({
            showToaster: false
        })
    }

    renderTabs = () => {

        let elemnets = []


        for (let i = 0; i < this.state.tabs.length; i++) {
            let tab = this.state.tabs[i]

            elemnets.push(
                <div className={`tab ${this.state.selectedTabValue == tab.value ? 'tab-active' : ''}`} onClick={() => this.onClickTab(tab.value)}>
                    <span className='pl-2 pr-2 pb-2'>{tab.title}</span>

                    {this.state.selectedTabValue == tab.value ? <div className='active-border'></div> : ''}
                </div>
            )
        }

        return elemnets
    }

    renderSetupClass() {
        return (
            <Modal className="cw-custom-modal" isOpen={true} toggle={this.hideSetupClass} size={"lg"}>
                <ModalBody >

                    <div className="row">
                        <div className="col text-right">
                            <img className="close-icon cursor-pointer" onClick={this.hideSetupClass} src={getImageSource(ImageConstants.CROSS)} />
                        </div>
                    </div>
                    <div className="header-text text-center">
                        <span>ADD NEW CLASS</span>
                    </div>
                    <div className="px-4">
                        <SetupClass onClose={this.hideSetupClass} onSave={this.hideSetupClass} classes={this.classes} />
                    </div>
                </ModalBody>
            </Modal>
        )
    }

    renderSetupSection() {
        return (
            <Modal className="cw-custom-modal modal-setup-section" isOpen={true} toggle={this.hideSetupClass} size={"lg"}>
                <ModalBody >

                    <div className="row">
                        <div className="col text-right">
                            <img className="close-icon cursor-pointer" onClick={this.hideSetupClass} src={getImageSource(ImageConstants.CROSS)} />
                        </div>
                    </div>
                    <div className="px-4">
                        <SetupSection onClose={this.hideSetupClass} hideSectionName={this.state.hideSectionName} title={this.state.hideSectionName ? 'NO' : "SETUP"} showToaster={this.showToaster} class={this.state.selectedTabValue} board={this.state.selectedBoard} />
                    </div>
                </ModalBody>
            </Modal>
        )
    }

    renderAddStudent() {
        return (
            <Modal className="cw-custom-modal" isOpen={true} toggle={this.closeAddStudentModal} size={"lg"}>
                <ModalBody >

                    <div className="row">
                        <div className="col text-right">
                            <img className="close-icon cursor-pointer" onClick={this.closeAddStudentModal} src={getImageSource(ImageConstants.CROSS)} />
                        </div>
                    </div>
                    <div className="header-text text-center">
                        <span>ADD A STUDENT</span>
                    </div>
                    <div className="p-4">
                        <AddStudentComponent mode="CREATE" selectedClass={this.state.selectedClass} size={'lg'} onSave={this.onSaveStudent.bind(this)} onClose={this.closeAddStudentModal.bind(this)} />
                    </div>
                </ModalBody>
            </Modal>)
    }



    render() {

        if (this.state.showStudentList) {
            return (
                <StudentList classDetails={this.state.selectedSection} goBack={this.handleback} history={this.props.history} />
            )
        }

        return (
            <div className='classes' onScroll={ReactTooltip.hide()}>

                <div className='row'>
                    <div className='col'>
                        <span className='screen-title'>CLASSES</span>
                    </div>

                    {
                        this.accessRights[AccessRights.ADD_CLASS] ?
                            <div className='col text-right'>
                                <div className='cw-button-md' onClick={this.showSetupClass}>
                                    ADD NEW CLASS
                                </div>
                            </div> : ""
                    }

                </div>
                {this.state.boards.length > 1 ?
                    < div className="board-tabs-wrapper p-4 mt-4">
                        <PillButtonSelect
                            key="pill"
                            onSelect={(value) => this.onSelectPillButton(value, "selectedBoard")}
                            options={this.state.boards}
                            value={this.state.selectedBoard}
                            width="150px"
                        />
                    </div> : ""
                }

                {this.renderTabs()}

                {
                    this.state.sections && this.state.sections.length ? this.renderSectionsList()
                        :
                        <>

                            <div className='no-record-container text-center'>
                                <div className="text-center mb-4">
                                    <div className='cw-button-md mr-2' onClick={() => this.showSetupSection(true)}>
                                        NO SECTIONS
                                    </div>
                                    <div className='cw-button-md' onClick={() => this.showSetupSection(false)}>
                                        SETUP SECTIONS
                                    </div>
                                </div>
                                <div className=''><img className='no-record-image' src={getImageSource(ImageConstants.NO_RECORDS)} /></div>
                                <div className='pt-2'><text >No data currently!!</text></div>
                            </div>
                        </>
                }

                {this.state.showSetupClass && this.renderSetupClass()}
                {this.state.showSetupSection && this.renderSetupSection()}
                {this.state.openAddStudent && this.renderAddStudent()}
                {this.state.showConfirmModal && <CWConfirm modal={this.state.showConfirmModal} close={this.hideConfirmModal} message={this.state.deleteMessage} onOk={this.removeSection.bind(this)} />}
                {this.state.showDeleteModal && <DeleteSection close={this.hideConfirmModal} section={this.state.deleteItem} onOk={this.onDeleteSuccess.bind(this)} />}
                {this.state.openAddTeacher && <AddTeacher onClose={this.closeAddTeacherModal} section={this.state.selectedClass} onSave={this.onTeacherAdded.bind(this)} />}
                {this.state.showToaster ? (
                    <div className='custom-toaster-modal'>
                        <ToasterComponent message={this.state.toasterMessage} type={this.state.toasterType} position="bottom-center" />
                    </div>
                ) : (
                    ''
                )}
                <ReactTooltip ref={el => this.tooltip = el} multiline={true} place='bottom' type='dark' effect='solid' event="mouseover mouseenter" eventOff="mouseleave mouseout scroll mousewheel blur" />
            </div >);
    }
}

export default Classes;